import { showLeaveWorkspaceModal } from "..";
import Graph from "./graph/graph";
import NodeExecutionTask from "./network/node-task";
import { loadCommentFramesAccordType } from "./nodes/local/logic/commentFrame";
import EventAnalytics from "./utilities/EventAnalytics";
import Eventor from "./utilities/Eventor";

let dom = {} as {
	canvasSpace: HTMLDivElement;
	graph: HTMLDivElement;
};

/**
 * events related to graph
 */
export enum GraphEvent {
	/**
	 * used in components that mounts before the graph creation, when this event fires, this features will fetch the graph instance and update their state
	 */
	GRAPH_CREATED = "GRAPH_CREATED",
	GRAPH_DESTROYED = "GRAPH_DESTROYED"
}

const graphConstructorEventor = new Eventor();

const context = {
	isStateSaved: false,
	graphConstructorEventor
} as {
	isStateSaved: boolean;
	graph: Graph;
	graphConstructorEventor: Eventor;
};

/**
 * on every mount SPA app is remounted, so we need to select new dom elements
 */
function resetDom() {
	dom = {
		canvasSpace: document.querySelector("#canvas-space") as HTMLDivElement,
		graph: document.querySelector("#graph") as HTMLDivElement
	};
}

/**
 * creates graph instance, restore the in-memory state of the previus graph that stored in global scope of this module
 */
const createNewGraph = async () => {
	resetDom();
	if (context.graph) {
		const state = await context.graph.serializeState(false, false);
		const oldGraph = context.graph;

		// Create new graph
		const newGraph = new Graph(dom.canvasSpace, dom.graph, false);
		newGraph.navigation.restorePosition(context.graph);
		context.graph = newGraph;

		// Clean up old graph after new one is ready
		oldGraph.destructor();

		// Restore state to new graph
		newGraph.pasteNodes(state?.nodes);
		loadCommentFramesAccordType(state.commentFrames);
		context.graphConstructorEventor.invoke(GraphEvent.GRAPH_CREATED);
		return;
	}
	context.graph = new Graph(dom.canvasSpace, dom.graph);
	context.graphConstructorEventor.invoke(GraphEvent.GRAPH_CREATED);
};

async function setCheckBeforeUnload() {
	if (window.location.href === "http://localhost:1234/") return;

	window.onbeforeunload = (e) => {
		NodeExecutionTask.stopTasksAsync(context.graph.nodes, true);
		EventAnalytics.tryReloadPage();
		if (context.graph.getIsSaved) {
			return;
		}
		e.preventDefault();
		e.returnValue = "Sure?";
		showLeaveWorkspaceModal();
		return "Sure?";
	};
}

const Editor = {
	createNewGraph,
	context,
	resetDom,
	setCheckBeforeUnload
};
export default Editor;
